// extracted by mini-css-extract-plugin
export default {"title":"SectionFeaturedListings_title__k2oPM h1 title","listingCards":"SectionFeaturedListings_listingCards__VXB1V","listingCard":"SectionFeaturedListings_listingCard__n7p7e"};